import SessionSales from './SessionSales';

export default (props) => <SessionSales {...props} />;
